import type { UI } from '@/v2/types';

import { uniq } from 'ramda';

const buildThemeSearchConfig = ({
  properties,
}: {
  properties: Array<UI.Property>;
}) => {
  const searchConfig = properties.reduce(
    (acc: UI.DestinationSearchConfig, property) => ({
      destinationCode: null,
      originCodes: uniq([
        ...acc.originCodes,
        ...(property?.destination?.searchConfig!.originCodes || []),
      ]),
      origins: uniq([
        ...acc.origins!,
        ...(property?.destination?.searchConfig!.origins || []),
      ]),
    }),
    {
      destinationCode: null,
      originCodes: [],
      origins: [],
    },
  );

  const blackoutDates = searchConfig.originCodes.reduce(
    (acc: UI.Destination['blackoutDates'], cur: string) => ({
      ...acc,
      [cur]: {
        departure: {},
        return: {},
      },
    }),
    {},
  );

  return {
    blackoutDates,
    searchConfig,
  };
};

export default buildThemeSearchConfig;
